<template>
  <section class='error404'>
    <img class="ot2_animation" src="../assets/img/ot2-animation.gif"></img>
    <div class="text">
      <h2>Sorry!</h2>
      <span>Protocol not found.</span>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'Error404Page'
  }
</script>

<style scoped>
  .error404{
    padding-top: 3em;
    color: #7b7b7b;
  }
  .ot2_animation{
    float: left;
    padding-right: 2em;
  }
</style>



// WEBPACK FOOTER //
// Error404Page.vue?9915dde2